/**
 * Scene Configuration Constants
 * Central location for all hardcoded values used in ThreeScene
 */

export const SCENE_CONFIG = {
  // Initial values
  INITIAL_ARROWS_RADIUS: 100,
  GRID_SIZE_MULTIPLIER: 3,
  DEFAULT_GRID_SIZE: 600,
  
  // Movement speeds
  MOVEMENT_SPEED: 1,
  APARTMENT_MOVEMENT_SPEED: 0.03,
  
  // Camera distances
  COLLISION_DETECTION_DISTANCE: 0.3,
  RAYCAST_MAX_DISTANCE: 500,
  
  // Animation durations
  DEFAULT_ANIMATION_DURATION: 1,
  CAMERA_ANIMATION_DURATION: 2,
  LOOK_AT_ANIMATION_DURATION: 2,
  FLOOR_ANIMATION_DURATION: 3,
  APARTMENT_ANIMATION_DURATION: 2,
  
  // Floor animation
  FLOOR_ANIMATION_STAGGER_DELAY: 0.05,
  FLOOR_MOVE_OFFSET: 1000,
  FLOOR_HEIGHT_OFFSET: 50,
  
  // Camera offsets
  HUMAN_HEIGHT_OFFSET: 2,
  APARTMENT_HEIGHT_OFFSET: 1,
  LABEL_HEIGHT_OFFSET: 30,
  BUILDING_LABEL_HEIGHT_OFFSET: 10,
  AREA_LABEL_HEIGHT_OFFSET: 20,
  
  // Model scales
  ARROW_SCALE: { x: 50, y: 50, z: 10 },
  LABEL_SCALE: { x: 10, y: 10, z: 1 },
  
  // Rotations
  ARROW_X_ROTATION: Math.PI / 2,
  ARROW_ROTATION_90: Math.PI / 2,
  ARROW_ROTATION_180: Math.PI,
  ARROW_ROTATION_270: -Math.PI / 2,
  
  // Shadow settings
  SHADOW_MAP_SIZE: 2048,
  SHADOW_CAMERA_NEAR: 0.5,
  SHADOW_CAMERA_FAR: 1000,
  SHADOW_CAMERA_EXTENT: 500,
  
  // Light settings
  AMBIENT_LIGHT_INTENSITY: 0.8,
  DIRECTIONAL_LIGHT_INTENSITY: 1,
  SUNLIGHT_POSITION: { x: 200, y: 200, z: 100 },
  
  // Arrow heights and positions
  ARROW_HEIGHT: 5,
  ARROW_LABEL_HEIGHT_OFFSET: 4,
  
  // Gradient texture
  GRADIENT_TEXTURE_SIZE: 2,
  
  // Look at calculation
  LOOK_AT_DISTANCE: 100,
  APARTMENT_CAMERA_Z_OFFSET: 40,
  
  // Animation easing
  DEFAULT_EASING: "power4.out",
  FLOOR_ANIMATION_EASING: "power2.out",
  
  // Grid settings
  GRID_DIVISIONS: 20,
};

export const DEFAULT_TRANSPARENCY = 0.3;
export const HOVERED_TRANSPARENCY = 0.9;
